module.exports = __webpack_public_path__ + "img/product_54.a9afd9c.svg";